// extracted by mini-css-extract-plugin
export default {"top_header":"XIyvDa8TlSpenOT9DF8k","topHeader":"XIyvDa8TlSpenOT9DF8k","shipping_banner":"E3kEzJk2tZbA1_JXBBEg","shippingBanner":"E3kEzJk2tZbA1_JXBBEg"};